import { Config } from "../Config/";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthHeader } from "../firebase/getAuthHeader";

const baseQuery = fetchBaseQuery({
  baseUrl: Config.API_URL,
  prepareHeaders: async (headers) => {
    try {
      const authHeader = await getAuthHeader();
      if (authHeader.Authorization) {
        headers.set("Authorization", authHeader.Authorization);
      }
      return headers;
    } catch (err) {
      return headers;
    }
  },
});

const baseQueryWithInterceptor = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error) {
    console.error("API Error:", result.error);

    if (result.error.status === 401) {
      console.warn("Authentication error detected");
    }
  }
  return result;
};

export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ["Users", "User", "UserSponsors", "Gifts"],
  endpoints: () => ({}),
});
